import React from 'react';
import Slider from 'react-slick';
import './slick.css';
import './slick-theme.css';
import './Industries.scss';
import bg21 from '../../../../../assets/images/bg21.png';
import image36 from '../../../../../assets/images/image36.png';
import image37 from '../../../../../assets/images/image37.png';
import image38 from '../../../../../assets/images/image38.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartbeat, faTruck, faPaw, faArrowRight, faSquare  } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const Industries = () => {
    const navigate = useNavigate(); 

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const industriesData = [
        {
            id: 1,
            icon: faSquare ,
            iconColor: '#007bff',
            image: image36,
            title: 'Healthcare',
            link: '/industries/healthcare',
            description: [
                'Welcome to KoolMind Technolab, where we redefine the digital landscape by crafting robust and scalable cross-platform mobile applications that set new standards in the era of mobile innovation. Our expert team of mobile application developers is dedicated to elevating the digital experience for users worldwide.',
                'As an innovative mobile app and web development company, we specialize in delivering natively compiled mobile applications that not only win the hearts of your target audience but also drive substantial revenue growth for your business.'
            ]
        },
        {
            id: 2,
            icon: faSquare,
            iconColor: '#3ddc84',
            title: 'Education',
            image: image37,
            link: '/industries/education',
            description: [
                'At KoolMind, we don\'t just build education apps; we craft digital experiences that transform disengaged students into passionate learners and supercharge your teaching team\'s impact. From interactive mobile apps students can\'t put down to web platforms that streamline your educators\' workflow, we deliver innovations that boost your enrollment and retention numbers hard.'
            ]
        },
        {
            id: 3,
            icon: faSquare,
            iconColor: '#9b51e0',
            image: image38,
            title: 'Pet Care',
            link: '/industries/pet-care',
            description: [
                'Welcome to KoolMind Technolab, where we redefine the digital landscape by crafting robust and scalable cross-platform mobile applications that set new standards in the era of mobile innovation. Our expert team of mobile application developers is dedicated to elevating the digital experience for users worldwide.',
                'As an innovative mobile app and web development company, we specialize in delivering natively compiled mobile applications that not only win the hearts of your target audience but also drive substantial revenue growth for your business.'
            ]
        }
    ];

    return (
        <section className="industries-section">
            <div className="industries-bg" style={{ backgroundImage: `url(${bg21})` }}></div>
            <div className="container">
                <div className="section-headers">
                    <h2>Industries</h2>
                    <p>Empowering diverse industries with tailored tech solutions</p>
                </div>

                <div className="industries-slider">
                    <Slider {...settings}>
                        {industriesData.map((industry) => (
                            <div key={industry.id} className="industry-slide">
                                <div className="industry-card">
                                    <div className="industry-icon">
                                        <FontAwesomeIcon icon={industry.icon} style={{ color: industry.iconColor, rotate: '45deg' }} />
                                        <span>{industry.title}</span>
                                    </div>
                                    <div className="industry-bg">
                                    </div>
                                    <div className="industry-content">
                                        <div className="industry-text">
                                            <h3>{industry.title}</h3>
                                            {industry.description.map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            ))}
                                            <button className="explore-more" onClick={() => navigate(industry.link)} style={{color: industry.iconColor}}>
                                                Explore More <FontAwesomeIcon icon={faArrowRight}  style={{marginLeft: '10px'}}/>
                                            </button>
                                        </div>
                                        <div className="industry-image">
                                            <img src={industry.image} alt={`${industry.title} illustration`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default Industries;